import styled from 'styled-components';
import React from 'react'; // Import React
import { useTranslation } from 'react-i18next'; // Import useTranslation

const Container = styled.div`
  background: ${(props) => props.theme.colors.surface}; /* Updated */
  color: ${(props) => props.theme.colors.textSecondary}; /* Updated for less emphasis */
  align-items: center;
  min-height: 60px; /* Kept min-height */
  /* max-height: 60px; Removed if padding is to be flexible, or adjust padding */
  height: 60px; /* Explicit height */
  display: flex;
  justify-content: space-between;
  padding: 0 20px; /* Updated padding */
  border-top: 1px solid ${(props) => props.theme.colors.borders}; /* Added border */

  @media (max-width: 600px) {
    flex-direction: column; /* Stack elements vertically */
    height: auto; /* Allow height to adjust to content */
    padding: 15px 20px; /* Adjust padding for stacked layout */
    gap: 10px; /* Add gap between stacked items */
    text-align: center; /* Center text when stacked */
  }
`;

const TextElement = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.secondary}; /* Added font family */
  font-size: ${(props) => props.theme.fontSizes.caption}; /* Updated font size */
  margin: 0; /* Remove default paragraph margins */
  /* Color will be inherited from Container */
`;

// No explicit props
interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const { t } = useTranslation(); // Initialize useTranslation
  return (
    <Container>
      <TextElement>{t('footer.copyright')}</TextElement>
      <TextElement>{t('footer.address')}</TextElement>
    </Container>
  );
}

export default Footer;
